// extracted by mini-css-extract-plugin
module.exports = {"root":"_2_3rp","fadeOutIn":"_129Zx"};